import "core-js/modules/es6.object.assign";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { forwardRef, createElement } from 'react';
var defaultElement = 'div';
var Box = forwardRef(function (_ref, ref) {
  var as = _ref.as,
      restProps = _objectWithoutProperties(_ref, ["as"]);

  var Element = as || defaultElement;
  return createElement(Element, Object.assign({
    ref: ref
  }, restProps));
});
export { Box };